import { useTheme } from '../../hooks/useTheme';
import { AppStateProvider } from '../../stores/contexts/AppStateContext';
import { ServiceLogo } from '../ServiceLogo';

import styles from './HeaderLogoOnly.module.scss';

import type { FC } from 'react';

import { AppEnv } from '@/packages/nurse-senka-frontend-sdk';

type Props = {
  appEnv: AppEnv;
};

// ヘッダーボディ
export const HeaderLogoOnly: FC<Props> = ({ appEnv }) => {
  const theme = useTheme();

  return (
    <AppStateProvider>
      <div className={styles.wrap}>
        <ServiceLogo appEnv={appEnv} theme={theme} />
      </div>
    </AppStateProvider>
  );
};
